import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { MediaContext } from 'react-media-query-hoc';
import { EventBoundary } from '@domain-group/fe-co-allhomes-analytics';
import { AllhomesArticleWrapper } from '@domain-group/fe-co-allhomes-article-card';
import { articleProps } from '../../common-props';
import * as styles from './suburb-articles.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var SuburbArticles = _ref => {
  var articles = _ref.articles,
    suburbName = _ref.suburbName,
    layout = _ref.layout;
  var _useContext = useContext(MediaContext),
    mobile = _useContext.mobile,
    desktop = _useContext.desktop,
    largeDesktop = _useContext.largeDesktop;
  return ___EmotionJSX("div", {
    css: styles.suburbArticles
  }, ___EmotionJSX("h3", {
    css: styles.title
  }, "About ", suburbName), ___EmotionJSX(EventBoundary, {
    name: "suburb-articles"
  }, ___EmotionJSX(AllhomesArticleWrapper, {
    layout: layout,
    fixedHeight: !(desktop || largeDesktop),
    target: "_blank",
    rel: "noopener",
    maxLines: !mobile ? 3 : 2 // eslint-disable-line no-negated-condition
    ,
    articles: articles.map(article => ({
      excerpt: article.title,
      tags: article.tags.filter(tag => tag.type === 'TAG').slice(0, 1),
      image: article.image,
      url: article.url
    }))
  })));
};
SuburbArticles.propTypes = {
  suburbName: PropTypes.string,
  articles: PropTypes.arrayOf(PropTypes.shape(articleProps)),
  layout: PropTypes.oneOf(['row', 'column', 'two-row'])
};
SuburbArticles.defaultProps = {
  suburbName: '',
  articles: [],
  layout: 'column'
};
export default SuburbArticles;